import { Card, Heading, Markdown } from '@frontendmentorio/design-system-v2';

export default function Brief({ challenge }) {
  return (
    <Card className="flex flex-col gap-4 p-5 tablet:row-span-2">
      <Heading className="flex gap-2" level="4" tagName="h2">
        <span>📝</span>
        Brief
      </Heading>

      <Markdown>{challenge.brief}</Markdown>
    </Card>
  );
}
